// extracted by mini-css-extract-plugin
export default {"linkContainer":"navlinks_linkContainer__cc2Wm","buttonToLink":"navlinks_buttonToLink__F2uGJ","linkSeparator":"navlinks_linkSeparator__7Nv48"};